module.exports = __webpack_public_path__ + "img/exam-bg.8b61f32e.png";